import { Component, OnInit } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./order-view.component.css']
})
export class OrderViewComponent implements OnInit {
  search_array = {};
  private sub: any;
  orderid = '';
  order: any = [];
  payment: any = [];
  customer: any = [];
  foodsordered: any = [];
  address: any = [];
  errorMessage = [];
  userloggedin: any = {};
  constructor(private orderView: WebApiObservableService, private routeparams: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    $('.spin').addClass('loading');
    this.userloggedin = JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
    this.sub = this.routeparams.params.subscribe(params => {
      this.orderid = params['id'];
      console.log(this.orderid)
      this.search_array = {
        customer_id: this.userloggedin.id,
        order_id: this.orderid
      };
      this.orderView
        .getServiceWithOrderDetail('/customerorders', this.search_array)
        .subscribe(
        result => {
          this.order = result.order_dtl;
          this.payment = result.payment_type;
          this.customer = result.customer;
          this.foodsordered = result.ordered_food;
          this.address = result.customer_address;
          $('.spin').removeClass('loading');
        },
        error => { $('.spin').removeClass('loading'); this.errorMessage = <any>error }
        );

    });



  }
  OnLogOut() {
    localStorage.clear();
    this.router.navigate(["home"]);
  }

  openAddresses() {
    this.router.navigate(["addresses"]);
  }

  openAccount() {
    this.router.navigate(["edit-account"]);
  }
}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/order-view/order-view.component.ts